import { render, staticRenderFns } from "./CourseViewFileModal.vue?vue&type=template&id=6fa1d0fd&"
import script from "./CourseViewFileModal.vue?vue&type=script&lang=ts&"
export * from "./CourseViewFileModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseViewFileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
